module.exports = __webpack_public_path__ + "static/media/hero-facilities.b317a007.jpg";